import { cx } from '@shared/lib/cx'
import { formatMoneyParts } from '@shared/lib/format/currency'
import { fraction, root, symbol } from './MoneyValue.css'

type MoneyValueFixedSize = 'sm' | 'md' | 'lg' | 'xl' | 'display'
type MoneyValueFractionSize = MoneyValueFixedSize | `fluid${Capitalize<MoneyValueFixedSize>}`

const fluidFractionSizes: Record<MoneyValueFixedSize, MoneyValueFractionSize> = {
  sm: 'fluidSm',
  md: 'fluidMd',
  lg: 'fluidLg',
  xl: 'fluidXl',
  display: 'fluidDisplay',
}

export type MoneyValueSize = MoneyValueFixedSize | 'fluid'

export type MoneyValueProps = {
  amount: string
  currency: string
  fractionDigits?: number
  size?: MoneyValueSize
  fractionSize?: MoneyValueFixedSize
  className?: string
}

export function MoneyValue({
  amount,
  currency,
  fractionDigits,
  size = 'md',
  fractionSize = 'xl',
  className,
}: MoneyValueProps) {
  const parts = formatMoneyParts(amount, currency, fractionDigits)
  const resolvedFractionSize = size === 'fluid' ? fluidFractionSizes[fractionSize] : size

  return (
    <span className={cx(root({ size }), 'vp-tabular', className)} data-money-value>
      <span className={symbol}>
        {parts.sign}
        {parts.symbol}
      </span>
      <span>{parts.integer}</span>
      {parts.fraction ? (
        <span className={fraction({ size: resolvedFractionSize })}>{parts.fraction}</span>
      ) : null}
    </span>
  )
}
